import React from 'react';
import { SbUnitModel } from '@/types';
import './bookContent.scss';

interface BookContentsProps {
  bookContents: SbUnitModel[];
  getBookPage: (pageNumber: number) => void; // Replace with a more specific type if available.
}

const BookContents: React.FC<BookContentsProps> = ({
  getBookPage,
  bookContents,
}) => {
  return (
    <div className="book-content-page">
      <div className="book-content-list">
        <ol className="toc-list" role="list">
          {bookContents &&
            bookContents.map((unit, index) => (
              <li key={`unit-${index}`}>
                <span onClick={() => getBookPage(unit.startPage)}>
                  <span className="book-content-title ">
                    {unit.name}
                    <span className="leaders" aria-hidden="true"></span>
                  </span>
                  <span className="page">
                    <span className="visually-hidden"></span> {unit.startPage}
                  </span>
                </span>
                <ol role="list">
                  {unit.unitContentModels &&
                    unit.unitContentModels.map((unitContent, subIndex) => (
                      <li key={`unitContent-${subIndex}`}>
                        <span
                          onClick={() =>
                            unitContent.startPage !== undefined &&
                            getBookPage(unitContent.startPage)
                          }
                        >
                          <span className="book-content-title">
                            {unitContent.name}
                            <span className="leaders" aria-hidden="true"></span>
                          </span>
                          <span className="page">
                            <span className="visually-hidden"></span>
                            {unitContent.startPage}
                          </span>
                        </span>
                      </li>
                    ))}
                </ol>
              </li>
            ))}
        </ol>
      </div>
    </div>
  );
};

export default BookContents;
